import { c as _c } from "react/compiler-runtime";
import { Button, Icon, Text } from '@chakra-ui/react';
import { LuChevronDown, LuFilter } from 'react-icons/lu';
import { PopoverTrigger } from '@/components/ui/popover';

/**
 * The ghost trigger button for a filter dropdown: a funnel icon, the current
 * selection label, and a chevron. Shared by the network browser's owner/type
 * filters and the assistant chat author filter, which all render a
 * byte-identical trigger. Rendered inside a `PopoverRoot` so `PopoverTrigger`
 * can wire up the popover via context.
 */
function FilterPopoverTrigger(t0) {
  const $ = _c(11);
  const {
    ariaLabel,
    active,
    label,
    disabled,
    fullWidth
  } = t0;
  const t1 = fullWidth ? "100%" : undefined;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Icon as={LuFilter} boxSize="14px" color="gray.500" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const t3 = fullWidth ? 1 : undefined;
  let t4;
  if ($[1] !== label || $[2] !== t3) {
    t4 = <Text flex={t3} lineClamp={1} textAlign="left">{label}</Text>;
    $[1] = label;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Icon as={LuChevronDown} boxSize="14px" color="gray.500" />;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== active || $[6] !== ariaLabel || $[7] !== disabled || $[8] !== t1 || $[9] !== t4) {
    t6 = <PopoverTrigger asChild={true}><Button aria-label={ariaLabel} aria-pressed={active} color="gray.700" disabled={disabled} fontSize="sm" fontWeight="medium" height="auto" justifyContent="flex-start" px={2} py={1} size="sm" variant="ghost" width={t1}>{t2}{t4}{t5}</Button></PopoverTrigger>;
    $[5] = active;
    $[6] = ariaLabel;
    $[7] = disabled;
    $[8] = t1;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}
export default FilterPopoverTrigger;